/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useNavigate } from "react-router-dom";

export default function RadialGraph({
  data,
  label,
  series,
  dataKey,
  queryString,
}: Readonly<{
  data: any;
  label: string;
  series: string;
  dataKey: string;
  queryString?: string;
}>) {
  const navigate = useNavigate();
  const [state, setState] = useState<{
    options?: ApexCharts.ApexOptions;
    series?: ApexAxisChartSeries | ApexNonAxisChartSeries;
  }>({
    series: [0],
    options: {
      chart: {
        height: 390,
        type: "radialBar",
        events: {
          dataPointSelection(event, chartContext, options) {
            const clickedPoint = options?.dataPointIndex;

            // Validate that clickedPoint exists within labels array
            if (
              clickedPoint !== undefined &&
              options.w.config?.labels?.[clickedPoint]
            ) {
              const status = options.w.config.labels[clickedPoint];

              setTimeout(() => {
                // eslint-disable-next-line no-console
                console.log("Clicked Value:", status);
                navigate(
                  `/dashboard-detail?${dataKey}=${status}${queryString}`
                );
              }, 100);
            } else {
              // eslint-disable-next-line no-console
              console.warn(
                "Clicked data is out of bounds or undefined",
                clickedPoint
              );
            }
          },
        },
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: "30%",
            background: "transparent",
            image: undefined,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
          barLabels: {
            enabled: true,
            useSeriesColors: true,
            offsetX: -8,
            fontSize: "16px",
            formatter(seriesName, opts) {
              return `${seriesName}:  ${opts.w.globals.series[opts.seriesIndex]}`;
            },
          },
        },
      },
      colors: [
        "#004D5F",
        "#006B84",
        "#0099BD",
        "#4DB8D1",
        "#99D6E5",
        "#E6F5F8",
      ],
      labels: ["Open"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              show: false,
            },
          },
        },
      ],
    },
  });

  useEffect(() => {
    if (data?.length) {
      setState((prevState) => ({
        options: {
          ...prevState.options,
          labels: data?.map((item: any) => item?.[label]),
        },
        series: data?.map((item: any) => item?.[series]),
      }));
    } else {
      setState((prevState) => ({
        options: {
          ...prevState.options,
          labels: [""],
        },
        series: [0],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <ReactApexChart
      options={state.options}
      series={state.series}
      type="radialBar"
      height={390}
    />
  );
}
